module.exports = __webpack_public_path__ + "img/index_side.097e1fd2.png";